import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/index/index.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
          path: '/',
          name: 'home',
          component: Home
        },
        {
          path: '/index',
          name: 'index',
          component: () => import('./views/index/index.vue')
        },
        {
          path: '/newActive',
          name: 'newActive',
          component: () => import('./views/newActive/newActive.vue')
        },
        {
          path: '/productIntro',
          name: 'productIntro',
          component: () => import('./views/productIntro/productIntro.vue')
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: () => import('./views/aboutUs/aboutUs.vue')
        },
        {
          path: '/applyUse',
          name: 'applyUse',
          component: () => import('./views/applyUse/applyUse.vue')
        },
        {
          path: '/APPdownload',
          name: 'APPdownload',
          component: () => import('./views/APPdownload/APPdownload.vue')
        },
        {
          path: '/newActive/news1',
          name: 'news1',
          component: () => import('./views/newActive/news1.vue')
        },
        {
          path: '/newActive/news2',
          name: 'news2',
          component: () => import('./views/newActive/news2.vue')
        },
        {
          path: '/newActive/news3',
          name: 'news3',
          component: () => import('./views/newActive/news3.vue')
        },
        {
          path: '/newActive/news4',
          name: 'news4',
          component: () => import('./views/newActive/news4.vue')
        },
        {
          path: '/newActive/news5',
          name: 'news5',
          component: () => import('./views/newActive/news5.vue')
        },
    ]
})
